import { render, staticRenderFns } from "./examRegistration.vue?vue&type=template&id=640d9832&"
import script from "./examRegistration.vue?vue&type=script&lang=js&"
export * from "./examRegistration.vue?vue&type=script&lang=js&"
import style0 from "./examRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports